export default __webpack_public_path__ + "static/media/dog-and-cat-d3.01029909.svg";